import { FC } from "react";
import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent from "./order-summary/order-optimizer-taxi-details-hidden-details-center-tables-orders-order-summary.component";
import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent from "./order/order-optimizer-taxi-details-hidden-details-center-tables-orders-order-table.component";
import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent from "./step-summary/order-optimizer-taxi-details-hidden-details-center-tables-orders-step-summary.component";
import {
  OrderOptimizerTaxiDetailsItemDriver,
  OrderOptimizerTaxiDetailsItemStepsOrdersPoints,
  OrderOptimizerTaxiDetailsItemOrders,
  OrderOptimizerTaxiDetailsItemStepsOrders,
} from "../../../common/types/order-optimizer-taxi-details-item";

type OrderOptimizerTaxiDetailsHiddenDetailsTablesOrdersProps = {
  driver: OrderOptimizerTaxiDetailsItemDriver | null;
  allStepPoints: OrderOptimizerTaxiDetailsItemStepsOrdersPoints[];
  order: OrderOptimizerTaxiDetailsItemOrders;
  step: OrderOptimizerTaxiDetailsItemStepsOrders;
  stepOffset: number;
  orderIndex: number;
};

const OrderOptimizerTaxiDetailsHiddenDetailsTablesOrdersComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsTablesOrdersProps
> = (props) => {
  return (
    <>
      <div className="order_optimizer_taxi_details_hidden_details_center_tables_orders">
        <div className="order_optimizer_taxi_details_hidden_details_center_tables_orders__left">
          <OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent
            order={props.order}
            orderIndex={props.orderIndex}
          />
        </div>
        <div className="order_optimizer_taxi_details_hidden_details_center_tables_orders__right">
          <div className="order_optimizer_taxi_details_hidden_details_center_tables_orders__right__order">
            <OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent
              driver={props.driver}
              allStepPoints={props.allStepPoints}
              stepPoints={props.step.points}
              stepOffset={props.stepOffset}
            />
          </div>
          <div className="order_optimizer_taxi_details_hidden_details_center_tables_orders__right__summary">
            <OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent
              driver={props.driver}
              step={props.step}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsTablesOrdersComponent;
